// The layers add up instead of stacking, so content that is the same in both stays fully opaque halfway through.
.crossfade {
  position: relative;
  align-self: stretch;
  isolation: isolate;
}

// Out of the flow, so the incoming content sets the height the wrapper animates to.
.leaving {
  position: absolute;
  inset: 0 0 auto;
  pointer-events: none;
  mix-blend-mode: plus-lighter;
  animation: fadeOut var(--route-crossfade-duration) ease forwards;
}

.entering {
  mix-blend-mode: plus-lighter;
  animation: fadeIn var(--route-crossfade-duration) ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}
